<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs5>
      <v-select
        v-model="query.operand"
        :items="operands"
        :item-disabled="itemDisabled"
        :item-text="itemText"
        :item-value="itemValue"
        dense
        solo
        @change="handleChangeOperand"
      />
    </v-flex>
    <v-flex xs2>
      <v-select
        v-model="query.operator"
        :items="_operators"
        :item-disabled="itemDisabled"
        :item-text="itemText"
        :item-value="itemValue"
        append-icon
        solo
        @change="handleChangeOperator"
      >
        <template
          slot="selection"
          slot-scope="data"
        >
          <div class="selected">
            {{ data.item.text }}
          </div>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      v-if="!unaryOperators.includes(query.operator)"
      xs5
    >
      <v-select
        v-if="queryValues(query)"
        v-model="query.value"
        :items="queryValues(query)"
        :item-disabled="itemDisabled"
        :item-text="itemText"
        :item-value="itemValue"
        single-line
        dense
        solo
        @change="handleChangeValue"
      />
      <v-text-field
        v-else
        v-model="query.value"
        dense
        solo
        @input="handleChangeValue"
        @keyup.native="handleEnterKeyUp"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    /**
     *
     */
    index: {
      type: String,
      default: '0'
    },
    position: {
      type: Number,
      default: 0
    },
    operators: {
      type: Array,
      required: true
    },
    operands: {
      type: Array,
      required: true
    },
    query: {
      type: Object,
      required: true
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  },

  data () {
    return {
      unaryOperators: ['$null', '$not_null']
    }
  },

  computed: {
    _operators () {
      const operandObject = this.operands.find(
        v => v.value === this.query.operand
      )
      if (operandObject && Array.isArray(operandObject.operator)) {
        return this.operators.filter(v =>
          operandObject.operator.includes(v.value)
        )
      }
      return this.operators
    }
  },

  methods: {
    handleChangeOperand (operand) {
      if (!this.operator) {
        this.query.operator = this.operators[0].value
      }
      this.query.value = ''
      this.$emit('change-operand', operand, this.query, [this.position])
    },

    handleChangeOperator (operator) {
      this.$emit('change-operator', operator, this.query, [this.position])
    },

    handleChangeValue (value) {
      this.$emit('change-value', value, this.query, [this.position])
    },

    handleEnterKeyUp (event) {
      if (event && event.code === 'Enter') {
        this.$emit('enter-keyup', event)
      }
    },

    itemDisabled (select) {
      return select.disabled || false
    },

    queryValues (query) {
      if (!query.operand) {
        return null
      }
      const operand = this.operands.find(v => v.value === query.operand)
      return operand.values
    }
  }
}
</script>
